module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper black",
    class: {
      'active': _vm.isMenuActive
    }
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        path: '/' + _vm.lang
      }
    }
  }, [_vm._v("Plastic Kills")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-trigger"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isMenuActive = !_vm.isMenuActive
      }
    }
  }, [_c('span')])]), _vm._v(" "), (_vm.isMenuActive) ? _c('div', {
    staticClass: "lang white"
  }, [_c('ul', {
    staticClass: "ul-horz"
  }, [(_vm.lang === 'es') ? _c('li', [_c('a', {
    staticClass: "title-font",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.lang = 'en'
      }
    }
  }, [_vm._v("English")])]) : _vm._e(), _vm._v(" "), (_vm.lang === 'en') ? _c('li', [_c('a', {
    staticClass: "title-font",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.lang = 'es'
      }
    }
  }, [_vm._v("Español")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMenuActive),
      expression: "isMenuActive"
    }],
    staticClass: "header-menu-wrapper"
  }, [_c('div', {
    staticClass: "span-full span-3 white"
  }, [_c('div', {
    staticClass: "item table-wrap"
  }, [_c('router-link', {
    staticClass: "table-cell",
    attrs: {
      "to": {
        name: 'Problems',
        params: {
          'lang': _vm.lang
        }
      }
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('div', {
    staticClass: "item-bg",
    staticStyle: {
      "background-image": "url('/static/images/menu-bag2.jpg')"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.problems[_vm.lang]))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item table-wrap"
  }, [_c('router-link', {
    staticClass: "table-cell",
    attrs: {
      "to": {
        name: 'Solutions',
        params: {
          'lang': _vm.lang
        }
      }
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('div', {
    staticClass: "item-bg",
    staticStyle: {
      "background-image": "url('/static/images/menu-bottle2.jpg')"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.solutions[_vm.lang]))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item table-wrap"
  }, [_c('a', {
    staticClass: "table-cell",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goFooter($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-bg",
    staticStyle: {
      "background-image": "url('/static/images/menu-seal2.jpg')"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.joinUs[_vm.lang]))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10078cb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 156
// module chunks = 1